'use strict';

var React = require('react');

var SvgTaxMajor = function SvgTaxMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.78 9.22a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.59 2c-.736 0-1.434.695-1.172 1.545a4.586 4.586 0 0 0 1.198 1.97 5.773 5.773 0 0 0-3.033 3.258l-1.046 2.83c-1.146 3.102 1.149 6.397 4.456 6.397h4.014c3.307 0 5.602-3.295 4.456-6.397l-1.046-2.83a5.774 5.774 0 0 0-3.033-3.258 4.585 4.585 0 0 0 1.198-1.97c.261-.85-.436-1.545-1.172-1.545h-4.82Zm2.41 3c-.788 0-1.573-.546-2-1.5h4c-.427.954-1.212 1.5-2 1.5Zm0 1.5a4.275 4.275 0 0 0-4.01 2.793l-1.046 2.83c-.784 2.123.786 4.377 3.049 4.377h4.014c2.263 0 3.833-2.254 3.049-4.377l-1.046-2.83a4.275 4.275 0 0 0-4.01-2.793Z"
  }));
};
SvgTaxMajor.displayName = "TaxMajor";

exports.SvgTaxMajor = SvgTaxMajor;
